var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RoleList"},[_c('XTable',{attrs:{"api":_vm.getRoleList,"state":_vm.roleList,"columns":_vm.columns,"loading":_vm.isBack,"tableSize":_vm.tableSize,"layout":_vm.layout,"maxHeight":_vm.maxHeight,"firstColumn":_vm.firstColumn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }